import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "pdt-30" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center pdb-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "Claim Submissions", -1)
const _hoisted_4 = { class: "filters d-flex gap-4 flex-wrap flex-md-nowrap justify-content-between w-100" }
const _hoisted_5 = { class: "d-flex gap-4 col-md-6 col-sm-12" }
const _hoisted_6 = { class: "small striped toggle no-underline min-height" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", { class: "large" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "pdl-10 pdr-10 d-flex justify-content-between w-100 table-header" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, "Claim #"),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, "Web Ref #"),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, "Rcpt Date"),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
          /*#__PURE__*/_createTextVNode("Participant "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" ID")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
          /*#__PURE__*/_createTextVNode("Participant "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" Name")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
          /*#__PURE__*/_createTextVNode("Patient "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" Name")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, "DOS"),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, "Relationship"),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "Notes"),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, "Status")
      ])
    ])
  ])
], -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "d-flex flex-column w-100 entry-row" }
const _hoisted_10 = { class: "d-flex justify-content-between flex-wrap flex-md-nowrap w-100 sm-gap-20" }
const _hoisted_11 = { class: "cell col-md-1 col-sm-5 d-flex justify-content-between align-items-center" }
const _hoisted_12 = { class: "cell col-md-1 col-sm-5 d-flex justify-content-between align-items-center" }
const _hoisted_13 = { class: "cell col-md-1 col-sm-5 d-flex justify-content-between align-items-center" }
const _hoisted_14 = { class: "cell col-md-1 col-sm-5 d-flex justify-content-between align-items-center" }
const _hoisted_15 = { class: "cell col-md-1 col-sm-5 text-wrap d-flex justify-content-between align-items-center" }
const _hoisted_16 = { class: "w-50" }
const _hoisted_17 = { class: "cell col-md-1 col-sm-5 text-wrap d-flex justify-content-between align-items-center" }
const _hoisted_18 = { class: "w-50" }
const _hoisted_19 = { class: "cell col-md-1 col-sm-5 text-wrap d-flex justify-content-between align-items-center" }
const _hoisted_20 = { class: "d-flex flex-column w-fit" }
const _hoisted_21 = { class: "text-start" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, " - ", -1)
const _hoisted_23 = { class: "text-start" }
const _hoisted_24 = { class: "cell col-md-1 col-sm-5 d-flex justify-content-between align-items-center" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "plan-modal iatse-icon-minus pdl-10"
}
const _hoisted_27 = {
  key: 1,
  class: "plan-modal iatse-icon-table-plus pdl-10"
}
const _hoisted_28 = { class: "cell col-md-1 col-sm-5 d-flex justify-content-between align-items-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "bullet" }, null, -1)
const _hoisted_30 = {
  key: 0,
  class: "text-center pdt-20 pdb-10"
}
const _hoisted_31 = { key: 2 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("tr", { class: "text-center py-5" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "8" }, " No submissions found ")
], -1)
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Alerts, {
      success: $setup.success,
      errors: $setup.errors
    }, null, 8, ["success", "errors"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.downloadCSV && $setup.downloadCSV(...args)))
        }, _toDisplayString($setup.loadingExport ? 'Exporting...' : 'Export To CSV'), 1)
      ]),
      _withDirectives(_createElementVNode("div", { class: "alert alert-success" }, _toDisplayString($setup.success), 513), [
        [_vShow, $setup.success]
      ]),
      _createElementVNode("form", {
        class: "bordered-card bordered-card_secondary",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_SelectComponent, {
              selectedOption: $setup.filters.Relationship,
              "onUpdate:selectedOption": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.Relationship) = $event)),
              options: $setup.relationships,
              "single-arrow": true
            }, null, 8, ["selectedOption", "options"]),
            _createVNode(_component_SelectComponent, {
              selectedOption: $setup.filters.ClaimStatus,
              "onUpdate:selectedOption": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters.ClaimStatus) = $event)),
              options: $setup.statuses,
              "single-arrow": true
            }, null, 8, ["selectedOption", "options"])
          ]),
          _createVNode(_component_TextInput, {
            name: "mixed",
            type: "text",
            placeholder: "Search by ID or Name...",
            max: 30,
            modelValue: $setup.filters.Participant,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters.Participant) = $event)),
            customClass: "search"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          ($setup.loading || $setup.loadingSearch)
            ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
            : ($setup.claimsHistory?.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.claimsHistory, (submission) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: submission.ClaimID,
                      class: _normalizeClass(['large', { 'closed': submission.Status === 'Closed' }])
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(submission.ClaimID), 1),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(submission.NEICID), 1),
                            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.useDateFormatter(submission.DateReceived)), 1),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(submission.PersonID), 1),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("span", _hoisted_16, _toDisplayString(submission.ParticipantName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(submission.PatientName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("span", _hoisted_21, _toDisplayString(submission.From_DOS), 1),
                                _hoisted_22,
                                _createElementVNode("span", _hoisted_23, _toDisplayString(submission.To_DOS), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_24, _toDisplayString(submission.Relationship), 1),
                            _createElementVNode("div", {
                              onClick: ($event: any) => ($setup.toggleNotes(submission.ClaimID ?? submission.NEICID)),
                              class: "cell col-md-2 col-sm-5 sm-pdl-0 pdr-25 d-flex justify-content-between align-items-center plan-modal"
                            }, [
                              _createElementVNode("span", null, _toDisplayString($setup.getTruncatedNotes(submission?.Notes)), 1),
                              (submission?.Notes?.length > 25)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    ($setup.isExpanded(submission.ClaimID ?? submission.NEICID))
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                                      : _createCommentVNode("", true),
                                    (!$setup.isExpanded(submission.ClaimID ?? submission.NEICID))
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_25),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("small", {
                                class: _normalizeClass(["label label_small w-fit", {
        'label_danger_secondary': ['Denied', 'Rejected'].includes(submission.ClaimStatus),
        'label_green_secondary': ['Received', 'Processed'].includes(submission.ClaimStatus),
        'label_blue': submission.ClaimStatus === 'In-Process'
    }
        ])
                              }, [
                                _hoisted_29,
                                _createTextVNode(" " + _toDisplayString(submission.ClaimStatus), 1)
                              ], 2)
                            ])
                          ]),
                          _createVNode(_Transition, { name: "slide-fade" }, {
                            default: _withCtx(() => [
                              ($setup.isExpanded(submission.ClaimID) && submission?.Notes?.length > 30)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createElementVNode("p", null, _toDisplayString(submission?.Notes), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ], 2))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_31, _hoisted_33))
        ]),
        (!$setup.loading && !$setup.loadingSearch)
          ? (_openBlock(), _createBlock(_component_PaginationComponent, {
              key: 0,
              paginator: $setup.paginator,
              onFetchData: $setup.fetchPaginationData
            }, null, 8, ["paginator", "onFetchData"]))
          : _createCommentVNode("", true)
      ], 32)
    ])
  ], 64))
}